import { Component, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiError, MessageService } from '../../../../../core';
import { ClienteCadastroSituacaoChart } from './cliente-cadastro-situacao-chart';
import { ClienteFilter } from '../../filter';
import { ClienteChartHttpService } from '../services';

@Component({
    selector: 'sgt-cliente-cadastro-situacao-chart',
    templateUrl: './cliente-cadastro-situacao-chart.component.html',
    styleUrls: ['./cliente-cadastro-situacao-chart.component.less']
})
export class ClienteCadastroSituacaoChartComponent {
    title = 'Cadastros e Situações';
    currentRequest: Subscription;
    isLoading: boolean;
    chart: ClienteCadastroSituacaoChart;


    constructor(private messageService: MessageService,
                private clienteChartHttpService: ClienteChartHttpService) { }


    load(filter: ClienteFilter) {
        this.showLoading();
        this.chart = null;
        this.currentRequest?.unsubscribe();
        this.currentRequest = this.clienteChartHttpService.loadCadastroSituacao(filter)
            .subscribe(
                chart => {
                    this.chart = chart;
                    this.show();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao carregar o gráfico de cadastros e situações dos clientes', error),
                () => this.hideLoading()
            );
    }


    private showLoading() {
        this.isLoading = true;
    }

    private hideLoading() {
        this.isLoading = false;
    }

    private show() {

    }
}
